import { render, staticRenderFns } from "./StockBarang.vue?vue&type=template&id=15825bba&scoped=true"
import script from "./StockBarang.vue?vue&type=script&lang=js"
export * from "./StockBarang.vue?vue&type=script&lang=js"
import style0 from "./StockBarang.vue?vue&type=style&index=0&id=15825bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15825bba",
  null
  
)

export default component.exports